import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import styled from 'styled-components'
import {MdOutlineMail} from 'react-icons/md'
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { send } from 'emailjs-com'
import InstagramEmbed from './InstagramEmbed';

// 📸 Link de la publicación de Instagram a mostrar en Contacto.
// Reemplazá esta URL por la del post que quieras destacar
// (en Instagram: "..." → "Copiar enlace"). Debe ser un link tipo
// https://www.instagram.com/p/XXXXXXXXXXX/
const INSTAGRAM_POST_URL = 'https://www.instagram.com/p/Dak0hfqxOrV/';

// Styled Components
const ContactContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    max-width: 1000px;
    margin: 0 auto;
    
    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 2rem;
    }
`;

const ContactOptions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const ContactOption = styled(motion.article)`
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 2rem;
    text-align: center;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
    }
`;

const ContactIcon = styled.div`
    font-size: 2rem;
    color: #18776a;
    margin-bottom: 1rem;
`;

const ContactTitle = styled.h4`
    color: #066a67;
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
`;

const ContactSubtitle = styled.h5`
    color: #7f8c8d;
    font-size: 1rem;
    margin-bottom: 1rem;
`;

const ContactLink = styled.a`
    color: #18776a;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
    
    &:hover {
        color: #066a67;
    }
`;

const ContactForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    padding: 2.5rem;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
`;

const FormInput = styled.input`
    padding: 1rem 1.5rem;
    border: 2px solid #e1e4d5;
    border-radius: 15px;
    font-size: 1rem;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    background: rgba(255, 255, 255, 0.8);
    
    &:focus {
        outline: none;
        border-color: #18776a;
        box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
    }
    
    &::placeholder {
        color: #95a5a6;
    }
`;

const FormTextarea = styled.textarea`
    padding: 1rem 1.5rem;
    border: 2px solid #e1e4d5;
    border-radius: 15px;
    font-size: 1rem;
    min-height: 120px;
    resize: vertical;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    background: rgba(255, 255, 255, 0.8);
    font-family: inherit;
    
    &:focus {
        outline: none;
        border-color: #18776a;
        box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
    }
    
    &::placeholder {
        color: #95a5a6;
    }
`;

const SubmitButton = styled(motion.button)`
    background: linear-gradient(135deg, #18776a 0%, #066a67 100%);
    color: white;
    border: none;
    padding: 1rem 2rem;
    border-radius: 15px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(52, 152, 219, 0.3);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

export default function Form() {
  const { t } = useTranslation()
  const form = useRef()

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ut6uoa9', 'template_8ux6nxa', form.current, 'SybZOjLNDyw1TH4SK')
      .then((result) => {
          console.log(result.text);
          alert('Mensaje enviado correctamente!');
      }, (error) => {
          console.log(error.text);
          alert('Error al enviar el mensaje. Por favor, inténtalo de nuevo.');
      });

    e.target.reset()
  };

  return (
    <ContactContainer>
      <ContactOptions>
        <ContactOption
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          <ContactIcon>
            <MdOutlineMail />
          </ContactIcon>
          <ContactTitle>Email</ContactTitle>
          <ContactSubtitle>nicovilao@gmail.com</ContactSubtitle>
          <ContactLink href="mailto:nicovilao@gmail.com" target='_blank' rel="noreferrer">
            Enviar mensaje
          </ContactLink>
        </ContactOption>
        
        <InstagramEmbed url={INSTAGRAM_POST_URL} />
      </ContactOptions>

      <ContactForm ref={form} onSubmit={sendEmail}>
        <FormInput
          type="text"
          name='name'
          placeholder={t("placeHolder1", "Nombre")}
          required
        />
        <FormInput
          type="text"
          name='zona'
          placeholder="Zona / Localidad"
          required
        />
        <FormInput
          type="text"
          name='cultivo'
          placeholder="Cultivo de interés"
        />
        <FormInput
          type="tel"
          name='telefono'
          placeholder="Teléfono"
          required
        />
        <FormInput
          type="email"
          name='email'
          placeholder={t("placeHolder2", "Email (opcional)")}
        />
        <FormTextarea
          name="message"
          placeholder={t("placeHolder3", "Mensaje (opcional)")}
        />
        <SubmitButton
          type='submit'
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Enviar Mensaje
        </SubmitButton>
      </ContactForm>
    </ContactContainer>
  )
}